import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')

const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffCrudReminders = () => import('./staff/crudReminders')

Vue.use(Router)

const router =
  [
    {
      path: '/st/reminders',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: 'RemindersStaffDashboard',
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Recordatorios',
          }
        },
        {
          path: 'list/:reminderId?',
          name: 'RemindersStaffCrud',
          component: ViewStaffCrudReminders,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Recordatorios Programados',
          }
        },
      ]
    },

    {
      path: '/cu/reminders',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/reminders',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
